import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import Modalexpercommentbacktbn from './Modalexpercommentbacktbn';


export default class Commentbnlist extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   expert_id:'',
   commentbn:[],
   
}


//this.handleSubmit = this.handleSubmit.bind(this);

this.toggle = this.toggle.bind(this);
this.list = this.list.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.getExpert()
;  this.props.selectex();
}


 componentDidMount() {
    //   const { id_send } = this.props.id_send
    //   console.log(id_send);
       this.setState({ id_send:this.props.id_send,
                       expert_id:this.props.expert_id,
         })
      setTimeout(() => {
       
         Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectcommentforbn.php?idexpert='+this.props.expert_id+'&id_send='+this.props.id_send)
        .then(res => {
          console.log(res);
       
          this.setState({ commentbn: res.data})
        }) 

      }, 0);

  }

  list() {
 
      setTimeout(() => {
         Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectcommentforbn.php?idexpert='+this.props.expert_id+'&id_send='+this.props.id_send)
        .then(res => {
          console.log(res);
          this.setState({ commentbn: res.data})
        }) 

      }, 0);

  }



    render() {
        

        return (
            <>
           <MDBTable>
      <MDBTableHead>
        <tr>
          <th>ลำดับ</th>
          <th>ไฟล์บทความ</th>
          <th>วันที่</th>
          <th>ไฟล์ข้อเสนอแนะ</th>
          <th>วันที่ส่งกลับ</th>
          <th>สถานะ ผ่าน/ไม่ผ่าน</th>
          <th>การส่งกลับ</th>
          
        </tr>
      </MDBTableHead>
      <MDBTableBody>
                      {this.state.commentbn.map((commentbn,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        {/* <td>{commentbn.fileword}</td> */}
                        <td>{commentbn.fileword !== null ? <>
                            <a href={`https://edu.kpru.ac.th/conference/PHPAPI/closeacticle/${commentbn.fileword}`}  target="_blank"><p className="green-text"><MDBIcon far icon="file-word" /> ไฟล์บทความ</p> </a>
                           </>:<><MDBIcon far icon="hourglass" /></>}</td>
                        <td>{commentbn.date_sentbn}</td>
                        {/* <td>{commentbn.filewordcomment_bn !== null ? <>{commentbn.filewordcomment_bn}</>:<><MDBIcon far icon="hourglass" /></>}</td> */}
                        <td>{commentbn.filewordcomment_bn !== null ? <>
                            <a href={`https://edu.kpru.ac.th/conference/PHPAPI/commentbn/${commentbn.filewordcomment_bn}`}  target="_blank"><p className="green-text"><MDBIcon far icon="file-word" /> ไฟล์บทความ</p> </a>
                           </>:<><MDBIcon far icon="hourglass" /></>}</td>
                        <td>{commentbn.date_senbacktbn !== null ?<>{commentbn.date_senbacktbn}</>:<><MDBIcon far icon="hourglass" /></>}</td>
                        <td>{commentbn.statuscomment_bn==='1'?<>ผ่าน</>:<>
                               {commentbn.statuscomment_bn==='0'?<>ไม่ผ่าน</>:<><MDBIcon far icon="hourglass" /></>}
                            </>}
                        </td>
                        <td>{commentbn.filewordcomment_bn !== null ?<>
                        ส่งกลับแล้ว
                        </>:<>
                          {commentbn.statuscomment_bn==='1'?<>แจ้งกลับแล้ว</>:<>
                          <Modalexpercommentbacktbn id_send={commentbn.id_send} id_comment={commentbn.id_comment} id_bn={commentbn.id_bn} list={this.list}  />
                          </>}
                        
                        </>}
                        {}
                            
                            </td>
                        </tr>
                      )}
       
      </MDBTableBody>
    </MDBTable>
           
          </>
          
        )
    }
}


